const initialLocation = new N.LatLng(37.4953092, 127.0286074);
const ReInitialLocation = new N.LatLng(37.4953094, 127.0286076);
const zoomControlInPC = location.href.indexOf('mobile') === -1;
const zoomControlPosition = location.href.indexOf('mobile') !== -1 ? N.Position.TOP_LEFT : N.Position.RIGHT_BOTTOM;

const mapOptions = {
  useStyleMap: true,
  center: initialLocation,
  minZoom: 7,
  zoom: 15,
  zoomControl: zoomControlInPC,
  zoomControlOptions: {
    position: zoomControlPosition,
    style: N.ZoomControlStyle.LARGE,
  },
  scaleControl: true,
  logoControl: true,
};

const mapDiv = document.getElementById('map');
const map = new N.Map('map', mapOptions);
window.map = map;

map.active = () => {
  mapDiv.style.pointerEvents = 'auto';
};

map.deactive = () => {
  mapDiv.style.pointerEvents = 'none';
};

map.deactive();

map.goCenter = (location, zoom = 15) => {
  map.setCenter(location); // 얻은 좌표를 지도의 중심으로 설정합니다.
  map.setZoom(zoom); // 지도의 줌 레벨을 변경합니다.

  map.active();
};

map.goDefault = () => {
  map.goCenter(ReInitialLocation);
  map.goCenter(initialLocation);
};

map.keyword = '';

map.setStopOnce = (isStopOnce) => {
  map.stopOnce = isStopOnce;
};

map.initialLocation = initialLocation;

window.map = map;

export default map;
